import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that automatically scrolls to top on route change
 * This fixes the issue where navigating to a new page maintains the previous page's scroll position
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever the pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'smooth' if you want smooth scrolling
    });
  }, [pathname]);

  return null; // This component doesn't render anything
}

export default ScrollToTop;
